import script from "./AuthCallback.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthCallback.vue?vue&type=script&setup=true&lang=js"

import "./AuthCallback.vue?vue&type=style&index=0&id=a88a5be8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a88a5be8"]])

export default __exports__